<!-- place holder for the text which contains the updates -->
<div #placeholder style="display: none">
  <ng-content></ng-content>
</div>

<!-- content where the ellipsed will rendered -->
<div #ellipsed>
</div>
